var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inPlayEventsMap && Object.keys(_vm.inPlayEventsMap).length > 0)?_c('v-card',{attrs:{"light":"","tile":"","flat":"","outlined":""}},[_vm._l((['4', '1', '2', '2378962']),function(key,i){return [(_vm.inPlayEventsMap[key])?_c('inplay-title',{key:'title' + i,attrs:{"category":_vm.inPlayEventsMap[key][0].eventType,"category-text":_vm.inPlayEventsMap[key][0].eventType}}):_vm._e(),_vm._v(" "),_vm._l((_vm.inPlayEventsMap[key]),function(eventItem){return [_c('inplay-odds',{key:eventItem &&
          eventItem.market &&
          eventItem.market.id &&
          'odds' + eventItem.market.id,class:{
          'bottom-radius': _vm.checkForLastElement(
            _vm.inPlayEventsMap[key].indexOf(eventItem),
            _vm.inPlayEventsMap[key]
          )
        },attrs:{"market":eventItem,"tv":!!eventItem.hasVideo}})]})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }